import { foundationAnchorStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
import { zeroButtonStyles } from '../button/button.styles';
export const zeroAnchorStyles = (context, definition) => css `
    ${foundationAnchorStyles(context, definition)}
    ${zeroButtonStyles(context, definition)}
  `.withBehaviors(...zeroButtonStyles(context, definition).behaviors);
